/**
 * BudgetApprovalService
 * Budget approval rows: per-budget history + the caller's approver inbox.
 * Routes: api/budgets/{budgetId}/approvals, api/budget-approvals/mine
 */
export class BudgetApprovalService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetApprovalService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(path) {
        const url = `${this.servicePath}/${path}`;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** Approval history of a budget (enriched views — lookup + user display fields). */
    async getByBudget(budgetId) {
        const response = await this.http.get(this.buildUrl(`api/budgets/${budgetId}/approvals`));
        return response.data ?? [];
    }
    /** Pending approval rows for the calling user (approver inbox). */
    async getMine() {
        const response = await this.http.get(this.buildUrl('api/budget-approvals/mine'));
        return response.data ?? [];
    }
}
BudgetApprovalService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetApprovalService.js.map